<div *ngIf="deviceType === 'mobile'" id="mobile-content">
  <div class="div">
    <img loading="lazy" src="assets/img/video-bg.png" class="img-mb" />
    <div class="div-2">
      <div class="div-3">
        <img loading="lazy" src="/assets/logos/rsi_logo.png" class="img-trm" />
        <div class="div-4">Seamless Rail solutions, Engineered For You</div>
        <div class="div-5">
          A powerful suite of tools designed to optimize your rail logistics
        </div>
      </div>
      <div class="div-6">
        <div class="div-7">
          <div class="div-8">
            <div class="div-9" (click)="loginWithRedirect()">sign in</div>
          </div>
          <div class="div-10">
            <div class="div-11" (click)="showLoginModal('waitlist')">
              request access
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="div-12">
      <div class="div-13">
        <div class="div-14">
          <div class="div-15">powered by</div>
          <div class="div-16">
            <img
              src="assets/img/rsi-logo.svg"
              class="img-2"
              alt="RSI Logistics"
            />
            <img
              src="assets/img/trinityrail_logo.svg"
              class="img-3"
              alt="TrinityRail"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="div-17">
      <div class="div-18">
        <img
          class="div-18 margin-none"
          src="assets/img/rsi-text.png"
          alt="rsi text"
        />
        <div class="div-19">
          <div class="div-20 mt-40">solutions</div>
          <div class="div-21">
            Optimize Your Rail Operations with Data-Driven Insights. Our
            platform brings together powerful tools designed to inform your
            strategy and optimize your supply chain.
            <br />
            <div class="div-30">
              Access Rail Network Performance analytics, Forecast & Demand
              insights, and—coming soon—the Railcar Parts Marketplace—all in one
              place. A single destination for comprehensive rail planning
              solutions, built to help you make smarter, faster decisions.
            </div>
          </div>
        </div>
        <div class="div-42">
          <img
            loading="lazy"
            src="assets/img/railnetwork-performance-mobile.png"
            class="img-6"
          />
          <div class="div-43">
            <div class="div-44">
              <img
                loading="lazy"
                src="assets/img/layer-1-1.svg"
                class="img-7"
              />
              <div class="div-45">Rail Network Performance</div>
            </div>
            <div class="div-26">
              Rail Network Performance provides you with the detailed insights
              you need to optimize your railcar fleet and network operations
              effectively
            </div>
            <div class="div-47">
              <div class="div-48">
                <div class="div-49">Understand Key Metrics Instantly</div>
                <div class="div-30">
                  Monitor key performance indicators, such as Railcar Volume,
                  Average Dwell Time, and Average Cycle Time, through intuitive
                  dashboards and visualizations.
                </div>
              </div>
              <div class="div-51">
                <div class="div-52">Analyze Historical Trends</div>
                <div class="div-30">
                  Dive deep into historical performance data across various
                  timeframes to identify patterns, bottlenecks, and
                  opportunities for improvement in your supply chain.
                </div>
              </div>
              <div class="div-54">
                <div class="div-55">Make Data-Driven Decisions</div>
                <div class="div-30">
                  Leverage comprehensive network analytics to inform strategic
                  planning, improve efficiency, and enhance overall operational
                  control.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div-37">
        <div class="div-22">
          <img
            loading="lazy"
            src="assets/img/forecast-demand-mobile.png"
            class="img-4"
          />
          <div class="div-23">
            <div class="div-24">
              <img
                loading="lazy"
                src="assets/img/forecast-icon.svg"
                class="img-5"
              />
              <div class="div-25">Forecast & Demand</div>
            </div>
            <div class="div-26">
              Empower your operations with data-driven insights into rail demand
              trends and service performance, enabling smarter planning and
              optimized resource use.
            </div>
            <div class="div-27">
              <div class="div-28">
                <div class="div-29">Volume Demand</div>
                <div class="div-30">
                  Track fulfilled and unfulfilled demand over time to identify
                  trends and optimize resource planning for enhanced service
                  capacity.
                </div>
              </div>
              <div class="div-31">
                <div class="div-32">Performance Accuracy</div>
                <div class="div-30">
                  Measure accuracy across first mile, last mile, and switching
                  performance to maintain dependable and efficient service.
                </div>
              </div>
              <div class="div-34">
                <div class="div-35">Forecast Summary</div>
                <div class="div-30">
                  Leverage forward-looking insights to stay ahead of future
                  demand and make informed decisions that drive operational
                  efficiency.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="div-38">
          <div class="div-39">coming soon</div>
          <div class="div-40">
            <div class="div-41" (click)="showLoginModal('waitlist')">
              get on the waitlist
            </div>
          </div>
        </div>
        <div class="div-57">
          <img
            loading="lazy"
            src="assets/img/marketplace-mobile.png"
            class="img-8"
          />
          <div class="div-58">
            <div class="div-59">
              <img
                loading="lazy"
                src="assets/img/layer-1-2.svg"
                class="img-9"
              />
              <div class="div-60">Parts Marketplace</div>
            </div>
            <div class="div-26">
              Streamline the discovery and procurement of essential railcar
              parts and components through a dedicated digital platform.
            </div>
            <div class="div-62">
              <div class="div-63">
                <div class="div-64">Find the Right Parts Quickly</div>
                <div class="div-30">
                  Easily search and browse our comprehensive catalog of railcar
                  parts and components, complete with detailed specifications
                  and information.
                </div>
              </div>
              <div class="div-66">
                <div class="div-67">Streamlined Ordering Process</div>
                <div class="div-30">
                  Leverage a simplified, efficient process for requesting quotes
                  and placing orders for necessary maintenance parts.
                </div>
              </div>
              <div class="div-69">
                <div class="div-70">Detailed Product Information</div>
                <div class="div-30">
                  Access accurate specifications, images, and compatibility
                  details to make sure you select the right part for your
                  maintenance needs.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img loading="lazy" src="assets/img/trm/TILX-360578.webp" class="img-18" />
  </div>
</div>

<div *ngIf="deviceType === 'tablet'" id="tablet-content">
  <div class="landing-page-tablet">
    <div class="div">
      <video class="img" autoplay muted loop id="background-video" playsinline>
        <source src="/assets/video/trm-landing-video.mp4" type="video/mp4" />
      </video>

      <div class="div-2">
        <img loading="lazy" src="/assets/logos/rsi_logo.png" class="img-2" />
        <div class="div-3">
          <div class="seamless-rail-solutions-engineered-for-you">
            Seamless Rail solutions, Engineered For You
          </div>
          <div
            class="a-comprehensive-suite-of-tools-to-help-deliver-the-best-in-rail-logistics"
          >
            A powerful suite of tools designed to optimize your rail logistics
          </div>
        </div>
        <div class="div-4">
          <div class="buttons">
            <div class="content" (click)="loginWithRedirect()">sign in</div>
          </div>
          <div class="buttons-2">
            <div class="content" (click)="showLoginModal('waitlist')">
              request access
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="div-8">
      <img
        loading="lazy"
        src="assets/img/landing-background.png"
        class="img-tab"
      />
      <div class="div-9">
        <div class="div-10">
          <img
            class="div-10 margin-none"
            src="assets/img/rsi-text.png"
            alt="rsi text"
          />
          <div class="div-11">
            <div class="solutions">solutions</div>
            <div
              class="railcar-search-is-the-new-name-of-trinity-marketplace-a-platform-that-allows-you-to-search-compare-and-reserve-railcars-from-trinity-rails-extensive-fleet-railcar-search-is-part-of-a-suite-of-solutions-that-we-are-launching-soon-to-enhance-your-rail-transportation-experience-join-our-waitlist-to-be-the-first-to-know-when-these-solutions-are-available"
            >
              Optimize Your Rail Operations with Data-Driven Insights. Our
              platform brings together powerful tools designed to inform your
              strategy and optimize your supply chain.
              <br />
              <div
                class="browse-our-lease-fleet-of-over-10-00-available-railcars-and-in-4-easy-steps-submit-a-quote"
              >
                Access Rail Network Performance analytics, Forecast & Demand
                insights, and—coming soon—the Railcar Parts Marketplace—all in
                one place. A single destination for comprehensive rail planning
                solutions, built to help you make smarter, faster decisions.
              </div>
            </div>
          </div>
          <div class="div-24">
            <div class="div-25">
              <div class="div-26">
                <div class="column">
                  <img
                    loading="lazy"
                    src="assets/img/railnetwork-performance-md.png"
                    class="img-6"
                  />
                </div>
                <div class="column-3">
                  <div class="div-27">
                    <div class="div-28">
                      <img
                        loading="lazy"
                        src="assets/img/layer-1-1.svg"
                        class="img-7"
                      />
                      <div class="rail-performance">
                        Rail Network Performance
                      </div>
                    </div>
                    <div
                      class="data-as-a-service-can-provide-you-with-all-the-details-you-need-to-best-optimize-your-railcar-fleet"
                    >
                      Rail Network Performance provides you with the detailed
                      insights you need to optimize your railcar fleet and
                      network operations effectively
                    </div>
                    <div class="div-29">
                      <div class="div-30">
                        <div class="lease-railcars-instantly">
                          Understand Key Metrics Instantly
                        </div>
                        <div
                          class="browse-our-lease-fleet-of-over-10-00-railcars-and-in-4-easy-steps-submit-a-quote-for-us-to-process"
                        >
                          Monitor key performance indicators, such as Railcar
                          Volume, Average Dwell Time, and Average Cycle Time,
                          through intuitive dashboards and visualizations.
                        </div>
                      </div>
                      <div class="div-31">
                        <div class="mobile-and-tablet-ready">
                          Analyze Historical Trends
                        </div>
                        <div
                          class="we-have-spend-time-creating-the-best-possible-experience-for-all-screen-sizes-so-that-you-can-use-railcar-search-wherever-you-go"
                        >
                          Dive deep into historical performance data across
                          various timeframes to identify patterns, bottlenecks,
                          and opportunities for improvement in your supply
                          chain.
                        </div>
                      </div>
                      <div class="div-32">
                        <div class="lease-brand-new-railcars">
                          Make Data-Driven Decisions
                        </div>
                        <div
                          class="dont-see-what-you-like-submit-a-quote-for-a-new-railcar-build-and-we-will-do-what-it-takes-to-get-you-the-car-you-need"
                        >
                          Leverage comprehensive network analytics to inform
                          strategic planning, improve efficiency, and enhance
                          overall operational control.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="div-22">
          <div class="div-12">
            <div class="div-13">
              <div class="column div-14">
                <img
                  loading="lazy"
                  src="assets/img/forecast-demand-md.png"
                  class="img-8"
                />
              </div>
              <div class="column-2">
                <div class="div-16">
                  <div class="div-17">
                    <img
                      loading="lazy"
                      src="assets/img/forecast-icon.svg"
                      class="img-5"
                    />
                    <div class="railcar-search">Forecast & Demand</div>
                  </div>
                  <div
                    class="search-our-entire-lease-fleet-as-well-as-explore-new-rail-car-builds-to-best-suit-your-needs"
                  >
                    Empower your operations with data-driven insights into rail
                    demand trends and service performance, enabling smarter
                    planning and optimized resource use.
                  </div>
                  <div class="div-18">
                    <div class="div-19">
                      <div class="effortlessly-request-quotes">
                        Volume Demand
                      </div>
                      <div
                        class="browse-our-lease-fleet-of-over-10-00-available-railcars-and-in-4-easy-steps-submit-a-quote"
                      >
                        Track fulfilled and unfulfilled demand over time to
                        identify trends and optimize resource planning for
                        enhanced service capacity.
                      </div>
                    </div>
                    <div class="div-20">
                      <div class="mobile-and-tablet-ready">
                        Performance Accuracy
                      </div>
                      <div
                        class="accessible-on-mobile-devices-ensuring-convenience-and-ease-for-our-clients-anytime-anywhere"
                      >
                        Measure accuracy across first mile, last mile, and
                        switching performance to maintain dependable and
                        efficient service.
                      </div>
                    </div>
                    <div class="div-21">
                      <div class="proactive-inventory-alerts">
                        Forecast Summary
                      </div>
                      <div
                        class="informing-you-about-relevant-inventory-updates-facilitating-smarter-more-informed-decisions"
                      >
                        Leverage forward-looking insights to stay ahead of
                        future demand and make informed decisions that drive
                        operational efficiency.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="div-23">
            <div class="coming-soon">coming soon</div>
            <div class="buttons-3">
              <div class="content" (click)="showLoginModal('waitlist')">
                get on the waitlist
              </div>
            </div>
          </div>
          <div>
            <div class="div-33">
              <div class="div-34">
                <div class="column">
                  <img
                    loading="lazy"
                    src="assets/img/gps-marketplace.png"
                    class="img-8"
                  />
                </div>
                <div class="column-4">
                  <div class="div-35">
                    <div class="div-36">
                      <img
                        loading="lazy"
                        src="assets/img/layer-1-2.svg"
                        class="img-9"
                      />
                      <div class="gps-marketplace">Parts Marketplace</div>
                    </div>
                    <div
                      class="use-our-gps-guidance-system-to-better-inform-where-your-railcars-are-and-how-to-automate"
                    >
                      Streamline the discovery and procurement of essential
                      railcar parts and components through a dedicated digital
                      platform.
                    </div>
                    <div class="div-37">
                      <div class="div-38">
                        <div class="browse-trinity-vetted-vendors">
                          Find the Right Parts Quickly
                        </div>
                        <div
                          class="explore-our-curated-list-of-top-rated-vendors-ensuring-you-have-access-to-the-best-services-and-products-for-your-rail-logistics-needs"
                        >
                          Easily search and browse our comprehensive catalog of
                          railcar parts and components, complete with detailed
                          specifications and information.
                        </div>
                      </div>
                      <div class="div-39">
                        <div class="gps-deployment-packages">
                          Streamlined Ordering Process
                        </div>
                        <div
                          class="optimize-your-fleet-operations-with-the-best-equipment-and-freight-car-tracking-technology-from-trinity-rail"
                        >
                          Leverage a simplified, efficient process for
                          requesting quotes and placing orders for necessary
                          maintenance parts.
                        </div>
                      </div>
                      <div class="div-40">
                        <div class="trinsight-trial-license">
                          Detailed Product Information
                        </div>
                        <div
                          class="try-trinsight-for-free-trinity-rails-rail-visibility-platform-is-designed-to-transform-data-into-visual-dashboards-for-enhanced-decision-making"
                        >
                          Access accurate specifications, images, and
                          compatibility details to make sure you select the
                          right part for your maintenance needs.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        loading="lazy"
        src="assets/img/trm/TILX-360578.webp"
        class="img-25"
      />
    </div>
  </div>
</div>

<div *ngIf="deviceType === 'desktop'" id="desktop-content">
  <div class="splash-container" id="div_splash-container_60266960">
    <div
      class="splash-container-images"
      id="div_splash-container-images_2d124af7"
    >
      <div class="div-2 pos">
        <video autoplay muted loop id="background-video" playsinline>
          <source src="/assets/video/trm-landing-video.mp4" type="video/mp4" />
        </video>
        <div class="div-3">
          <img loading="lazy" src="/assets/logos/rsi_logo.png" class="img-2" />
          <div class="div-4">Seamless Rail solutions, Engineered For You</div>
          <div class="div-5">
            A powerful suite of tools designed to optimize your rail logistics
          </div>
          <div class="div-6">
            <div class="div-7" (click)="loginWithRedirect()">sign in</div>
            <div class="div-8" (click)="showLoginModal('waitlist')">
              request access
            </div>
          </div>
        </div>
      </div>
      <div class="div-12">
        <img
          class="div-13 margin-none"
          src="assets/img/rsi-text.png"
          alt="rsi text"
        />
        <div class="div-13">
          <div class="div-14">solutions</div>
          <div class="div-15">
            Optimize Your Rail Operations with Data-Driven Insights. Our
            platform brings together powerful tools designed to inform your
            strategy and optimize your supply chain.
            <br />
            <div class="div-25">
              Access Rail Network Performance analytics, Forecast & Demand
              insights, and—coming soon—the Railcar Parts Marketplace—all in one
              place. A single destination for comprehensive rail planning
              solutions, built to help you make smarter, faster decisions.
            </div>
          </div>
          <br />
        </div>
        <div class="div-33">
          <div class="div-34">
            <div class="column">
              <img
                loading="lazy"
                src="assets/img/railnetwork-performance.png"
                class="img-7"
              />
            </div>
            <div class="column-5">
              <div class="div-35">
                <div class="div-36">
                  <div class="div-37">
                    <div class="column-6">
                      <img
                        loading="lazy"
                        src="assets/img/layer-1-1.svg"
                        class="img-8"
                      />
                    </div>
                    <div class="column-7">
                      <div class="div-38">Rail Network Performance</div>
                    </div>
                  </div>
                </div>
                <div class="div-39">
                  Rail Network Performance provides you with the detailed
                  insights you need to optimize your railcar fleet and network
                  operations effectively
                </div>
                <div class="div-40">Understand Key Metrics Instantly</div>
                <div class="div-41">
                  Monitor key performance indicators, such as Railcar Volume,
                  Average Dwell Time, and Average Cycle Time, through intuitive
                  dashboards and visualizations.
                </div>
                <div class="div-42">Analyze Historical Trends</div>
                <div class="div-43">
                  Dive deep into historical performance data across various
                  timeframes to identify patterns, bottlenecks, and
                  opportunities for improvement in your supply chain.
                </div>
                <div class="div-44">Make Data-Driven Decisions</div>
                <div class="div-45">
                  Leverage comprehensive network analytics to inform strategic
                  planning, improve efficiency, and enhance overall operational
                  control.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="div-16">
          <div class="div-17">
            <div class="column">
              <div class="div-18">
                <img
                  loading="lazy"
                  src="assets/img/forecast-demand.png"
                  class="img-5"
                />
              </div>
            </div>
            <div class="column-2">
              <div class="div-19">
                <div class="div-20">
                  <div class="div-21">
                    <div class="column-3">
                      <img
                        loading="lazy"
                        src="assets/img/forecast-icon.svg"
                        class="img-6"
                      />
                    </div>
                    <div class="column-4">
                      <div class="div-22">Forecast & Demand</div>
                    </div>
                  </div>
                </div>
                <div class="div-23">
                  Empower your operations with data-driven insights into rail
                  demand trends and service performance, enabling smarter
                  planning and optimized resource use.
                </div>
                <div class="div-24">Volume Demand</div>
                <div class="div-25">
                  Track fulfilled and unfulfilled demand over time to identify
                  trends and optimize resource planning for enhanced service
                  capacity.
                </div>
                <div class="div-26">Performance Accuracy</div>
                <div class="div-27">
                  Measure accuracy across first mile, last mile, and switching
                  performance to maintain dependable and efficient service.
                </div>
                <div class="div-28">Forecast Summary</div>
                <div class="div-29">
                  Leverage forward-looking insights to stay ahead of future
                  demand and make informed decisions that drive operational
                  efficiency.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="div-middle-img">
          <img
            loading="lazy"
            src="assets/img/high-speed.png"
            class="base-image"
          />
          <img
            loading="lazy"
            src="assets/img/high-speed-text.png"
            class="overlay-image"
            (click)="showLoginModal('waitlist')"
          />
        </div>
        <div class="div-30">
          <div class="div-31">coming soon</div>
          <div class="div-32" (click)="showLoginModal('waitlist')">
            get on the waitlist
          </div>
        </div>
        <div class="div-46">
          <div class="div-47">
            <div class="column">
              <img
                loading="lazy"
                src="assets/img/gps-marketplace.png"
                class="img-9"
              />
            </div>
            <div class="column-8">
              <div class="div-48">
                <div class="div-49">
                  <div class="div-50">
                    <div class="column-9">
                      <img
                        loading="lazy"
                        src="assets/img/layer-1-2.svg"
                        class="img-10"
                      />
                    </div>
                    <div class="column-10">
                      <div class="div-51">Parts Marketplace</div>
                    </div>
                  </div>
                </div>
                <div class="div-52">
                  Streamline the discovery and procurement of essential railcar
                  parts and components through a dedicated digital platform.
                </div>
                <div class="div-53">Find the Right Parts Quickly</div>
                <div class="div-54">
                  Easily search and browse our comprehensive catalog of railcar
                  parts and components, complete with detailed specifications
                  and information.
                </div>
                <div class="div-55">Streamlined Ordering Process</div>
                <div class="div-56">
                  Leverage a simplified, efficient process for requesting quotes
                  and placing orders for necessary maintenance parts.
                </div>
                <div class="div-57">Detailed Product Information</div>
                <div class="div-58">
                  Access accurate specifications, images, and compatibility
                  details to make sure you select the right part for your
                  maintenance needs.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="businedd-delivery-panel">
        <img class="img-fluid" src="assets/img/features.png" alt="features" />
      </div>
      <br />
      <div
        class="businedd-delivery-panel"
        id="div_businedd-delivery-panel_94bd00e411"
      >
        <div class="powered-by-container">
          <h2 class="powered mt-3">Powered By</h2>
          <div class="d-flex justify-content-center align-items-center mb-3">
            <img
              src="assets/img/rsi-logo.svg"
              class="img-fluid"
              alt="RSI Logistics"
            />
            <img
              src="assets/img/trinityrail_logo.svg"
              class="img-fluid"
              alt="TrinityRail"
            />
          </div>
        </div>
        <div class="tilx-360578" id="div_tilx-360578_9c69c47911">
          <img
            alt="TRM image"
            aria-label="TRM image"
            title="TRM image"
            src="assets/img/trm/TILX-360578.webp"
            id="img_57badb9b11"
          />
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_707f3c2f"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_dfe1e5ee"
  ></p-progressSpinner>
</div>
